const setPageLevelTargeting = ({ targeting }) => {
  window.googletag.cmd.push(() => {
    Object.entries(targeting).forEach(entry => {
      window.googletag.pubads().setTargeting(...entry);
    });
  });
};

export default setPageLevelTargeting;
